<app-dialog-header
    [title]="isEditDialog ? 'USER.BUTTON.EDIT_PASSWORDLESS_ACCESS' : 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS'"
    [additionalText]="!selectedUserIds.length ? null : '(' + selectedUserIds.length + ')'"
    (onClick)="dialogRef.close(false)"
></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <form [formGroup]="formGroup">
        <ng-container>
            <label class="datepicker-label">{{ 'GENERAL.PROPERTY.START' | translate }}</label>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="16px" class="mb-24">
                <mat-form-field class="w-100-p">
                    <input
                        matInput
                        name="startDate"
                        [max]="maxDate"
                        [min]="today"
                        formControlName="startDate"
                        [matDatepicker]="pickerStartDate"
                        [placeholder]="'GENERAL.PROPERTY.CHOOSE_DATE' | translate"
                        (focus)="pickerStartDate.open()"
                        (ngModelChange)="updateEndDate()"
                    />
                    <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="w-100-p">
                    <input matInput [cleave]="{ time: true, timePattern: ['h', 'm'] }" formControlName="startTime" [placeholder]="'GENERAL.PROPERTY.TIME' | translate" />
                    <mat-icon class="timepicker-icon">access_time</mat-icon>
                </mat-form-field>
            </div>
        </ng-container>
        <ng-container>
            <label class="datepicker-label">{{ 'GENERAL.PROPERTY.END' | translate }}</label>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="16px" class="mb-24">
                <mat-form-field class="w-100-p">
                    <input
                        matInput
                        name="endDate"
                        [min]="minDate"
                        [max]="maximumPossibleDate"
                        formControlName="endDate"
                        [matDatepicker]="pickerEndDate"
                        [placeholder]="'GENERAL.PROPERTY.CHOOSE_DATE' | translate"
                        (focus)="pickerEndDate.open()"
                        (dateChange)="updateStartDate()"
                    />
                    <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="w-100-p">
                    <input matInput [cleave]="{ time: true, timePattern: ['h', 'm'] }" formControlName="endTime" [placeholder]="'GENERAL.PROPERTY.TIME' | translate" />
                    <mat-icon class="timepicker-icon">access_time</mat-icon>
                </mat-form-field>
            </div>
        </ng-container>
        <mat-checkbox formControlName="generateAccessCode" *ngIf="!isEditDialog">{{ 'PASSWORDLESS_ACCESS.DIALOG.LABEL.GENERATE_ACCESS_CODE' | translate }}</mat-checkbox>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="isEditDialog ? 'GENERAL.BUTTON.SAVE' : 'GENERAL.BUTTON.CREATE'"
        (onClick)="save()"
        [isLoading]="isSaveInProgress"
        [disabled]="!formGroup.valid"
    ></app-flat-button>
</div>
